export default __webpack_public_path__ + "8fdd4eb195477d49481ccf1fa2a343b4.png";